import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "printMe",
  class: "flex max-h-[500px] flex-col items-center space-y-4 overflow-y-scroll"
}
const _hoisted_2 = { class: "flex space-x-4" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "flex flex-col items-center border border-lightgray p-2" }
const _hoisted_5 = { class: "pb-2 text-center text-[8px]" }
const _hoisted_6 = { class: "flex flex-col items-center border border-lightgray p-2" }
const _hoisted_7 = { class: "pb-2 text-center text-[9px]" }
const _hoisted_8 = { class: "flex flex-col items-center border border-lightgray p-2" }
const _hoisted_9 = { class: "pb-2 text-center text-[10px]" }
const _hoisted_10 = { class: "flex flex-col items-center border border-lightgray p-2" }
const _hoisted_11 = { class: "pb-2 text-center text-[11px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createBlock(_component_modal, {
    "is-displayed": _ctx.isQrModalOpened,
    "no-padding": true,
    title: _ctx.deviceDetails.name,
    "have-modal": _ctx.haveModal,
    onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("b", null, "Device UUID:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.deviceDetails.uuid), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_qrcode_vue, {
            size: 80,
            value: `https://a.spotium.hr/act?uuid=${_ctx.deviceDetails.uuid}`,
            level: "L"
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.deviceDetails.name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_qrcode_vue, {
            size: 130,
            value: `https://a.spotium.hr/act?uuid=${_ctx.deviceDetails.uuid}`,
            level: "L"
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.deviceDetails.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_qrcode_vue, {
            size: 220,
            value: `https://a.spotium.hr/act?uuid=${_ctx.deviceDetails.uuid}`,
            level: "L"
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.deviceDetails.name), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_qrcode_vue, {
            size: 300,
            value: `https://a.spotium.hr/act?uuid=${_ctx.deviceDetails.uuid}`,
            level: "L"
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.deviceDetails.name), 1)
        ])
      ]),
      _withDirectives(_createVNode(_component_the_button, {
        "button-type": "primaryButton",
        size: "full",
        text: "Print"
      }, null, 512), [
        [_directive_print, '#printMe']
      ])
    ]),
    _: 1
  }, 8, ["is-displayed", "title", "have-modal"]))
}